import React, { Component } from "react";
import Button from "../reusable/components/Button.jsx";
import baseurl from "../api-properties";
import {getAuthToken} from "../reusable/basic-auth-creds";

class FinacilaSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prosSuppId: this.props.companyInfoObjFIN.prosSuppId,
      prosNumber: this.props.companyInfoObjFIN.prosNumber,
      geographicalJson: [],
      standardCertOptions: [],
      standardCertFileList: []
    };
    this.handleFinacialEditBtn = this.handleFinacialEditBtn.bind(this);
  }
  componentDidMount() {
    let prosSuppId = this.state.prosSuppId;
    this.loadGeographicalList(prosSuppId);
    this.loadStandardCertOptions(prosSuppId);
  }
  loadGeographicalList = (prosSuppId) => {
    fetch(baseurl.FINACIAL_API_URL + "financial/getGeographical/" + prosSuppId, {
      method: "GET",
          headers: {
        Accept: "application/json",
            "Content-Type": "application/json",
            "Authorization": "Basic " + getAuthToken()
      }})
      .then((response) => {
        if (response.status === 401 || response.status === 403) {
          window.location.href = "/error";
        }
        return response.json();
      })
      .then(data => {
        if (data !== undefined && data != null)
          this.setState({ geographicalJson: data });
      }).catch(error => {
        console.log(error);
      });
  }

  loadStandardCertOptions = (prosSuppId) => {
    let jsonData = { "paramCategory": "CERTIFIED_TYPE" };
    fetch(baseurl.PROS_SUPNET_API_URL + "ps/getParams/", {
      method: "POST",
      body: JSON.stringify(jsonData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": "Basic " + getAuthToken()
      }
    }).then(response => {
      if (response.status === 401 || response.status === 403) {
        window.location.href = "/error";
      }
      return response.json();
    }).then(data => {
      if (data !== undefined && data != null) {
        let standardCerts = data.map(result => { return { value: result.paramCode, display: result.paramValue } })
        this.setState({ standardCertOptions: standardCerts });
        this.loadCertFiles(prosSuppId);
      }
    }).catch(error => {
      console.log(error);
    });
  }

  loadCertFiles = (prosSuppId) => {
    fetch(baseurl.FINACIAL_API_URL + "financial/retrieveFileName/" + prosSuppId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": "Basic " + getAuthToken()
      }})
      .then((response) => {
        if (response.status === 401 || response.status === 403) {
          window.location.href = "/error";
        }
        return response.json();
      })
      .then(data => {
        if (data !== undefined && data != null)
          this.setState({ standardCertFileList: data });
      }).catch(error => {
        console.log(error);
      });
  }

  getStandardCertName = (certId) => {
    let textValue = "";
    let jsonData = this.state.standardCertOptions;
    jsonData.map((standardCertOptObj) => {
      if (certId === standardCertOptObj.value) {
        textValue = standardCertOptObj.display;
      }
    })
    return textValue;
  }

  downloadStandardCertFile = (e, fileName) => {
    e.preventDefault();
    fileName = fileName.replace(/\|/g, ':');
    fetch(baseurl.FINACIAL_API_URL + "financial/downloadFile/?fileName=" + fileName, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": "Basic " + getAuthToken()
      }})
      .then(response => {
        if (response.status === 401 || response.status === 403) {
          window.location.href = "/error";
        }
        return response.text();
      }).then(data => {
        if (data !== undefined && data != null) {
          window.open(data, "_blank");
        }
      }).catch(error => {
        console.log(error);
      });
  }

  handleFinacialEditBtn() {
    document.location.href = "/diversity-finacial-info/" + this.state.prosNumber;
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-8">
            <div><label className="uxf-label">Business Type</label></div>
            <div><label>{this.props.finacialInfoData.businessTypeName}</label></div>
          </div>
          <div className="col-sm-8">
            <div><label className="uxf-label">Year Established</label></div>
            <div><label>{this.props.finacialInfoData.establishedYear}</label></div>
          </div>
          <div className="col-sm-8">
            <div><label className="uxf-label">Previous Years Sales</label></div>
            <div><label>{this.props.finacialInfoData.prevYearCurrencyName}</label></div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8">
            <div><label className="uxf-label">Private Or Public Trade</label></div>
            <div><label>{this.props.finacialInfoData.tradedName}</label></div>
          </div>
          <div className="col-sm-8">
            <div><label className="uxf-label">Number of Facilities</label></div>
            <div><label>{this.props.finacialInfoData.noFacilities}</label></div>
          </div>
          <div className="col-sm-4">
            <div><label>{this.props.finacialInfoData.prevYearValue1}</label></div>
            <div><label>{this.props.finacialInfoData.prevYearValue2}</label></div>
            <div><label>{this.props.finacialInfoData.prevYearValue3}</label></div>
          </div>
          <div className="col-sm-4">
            <div><label>({this.props.finacialInfoData.prevYearTitle1})</label></div>
            <div><label>({this.props.finacialInfoData.prevYearTitle2})</label></div>
            <div><label>({this.props.finacialInfoData.prevYearTitle3})</label></div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8">
            <div><label className="uxf-label">Full Legal Name of Owner</label></div>
            <div><label>{this.props.finacialInfoData.ownerLegalName}</label></div>
          </div>
          <div className="col-sm-8">
            <div><label className="uxf-label">Number of Employees</label></div>
            <div><label>{this.props.finacialInfoData.noTotalEmployee}</label></div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-24">
            <div><label className="uxf-label">Geographical Service Area</label></div>
            {Object.values(this.state.geographicalJson).filter((geographicalObj) => geographicalObj.isSelected === true).map((geographical, index) =>
              <span>{index !== 0 ? ",  " : ""}<label>{geographical.geographicalName}</label></span>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-24">
            <div><label className="uxf-label">Standard Certifications</label></div>
            {(this.state.standardCertFileList !== null && this.state.standardCertFileList.length > 0) ?
              Object.values(this.state.standardCertFileList).map((attachment) =>
                <div><label>{this.getStandardCertName(attachment.split('|')[1].trim())}</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="#" onClick={(event) => this.downloadStandardCertFile(event, attachment)}>{attachment.split('|')[2].trim()}</a></div>
              )
              : null
            }
            {/*
            BELOW CODE REQUIRED IF WE ARE GOING TO USE APP_FILES Table.
            {(this.props.finacialInfoData.fileAttachment != null) ?
              Object.values(this.props.finacialInfoData.fileAttachment).map((attachment, index) =>
                <div><label>{attachment.certificateName}</label>&nbsp;&nbsp;&nbsp;<a href="#">{attachment.fileName}</a></div>
              )
              : null
            }*/
            }
          </div>
        </div>
        <div className= "row">
        <div className="col-sm-24">
            <div><label className="uxf-label">Comments</label></div>
            <div><label>{this.props.finacialInfoData.comments}</label></div>
          </div>
          </div>
        {this.props.companyInfoObjFIN.userRole !== undefined && this.props.companyInfoObjFIN.userRole !== null && this.props.companyInfoObjFIN.userRole !== "VIEW_ONLY"
          && this.props.companyInfoObjFIN.status !== "A" && this.props.companyInfoObjFIN.status !== "D" && this.props.companyInfoObjFIN.status !== "N" ?
          <div className="row">
            <div className="col-sm-24" style={{ textAlign: 'right' }}>
              <Button action={this.handleFinacialEditBtn} type="secondary" title="Edit" />{" "}
            </div>
          </div>
          : ''}
      </div>
    )
  }
}
export default FinacilaSummary;